window.addEventListener("load", () => {
  const activeTab = document.querySelector(".tabs-nav_item.-active")
  if (activeTab) {
    activeTab.scrollIntoView({ block: "end", inline: "center" })
  }
})
